import App from "../index";
import anime, { AnimeInstance } from "animejs";
import { findParentEl, getEl, getEls } from "../helpers";
import { ScrollDirection } from "../classes/scroll-manager";

/**
 * Finds all elements on the page with the .anim-image class and adds an animation to them.
 * If they also have the .autoplay class then they perform the animation once they are scrolled
 * and visible on the screen.
 * If not, they have a custom event listener attached called "play". If you dispatch an event to
 * that then they will start their animation:
 *
 *  element.dispatchEvent("play");
 *
 */
export default class AnimatedImages
{
	static TRIGGER_ANIMATION_AT = 0.8; //How far down the page to trigger the animation expressed as a ratio of window height. 0 = top of the page, 1 = bottom of the page.

	//private app: App;

	// private images: {
	// 	el: Element,
	// 	anim: AnimeInstance,
	// }[] = [];

	constructor(app: App) {

		let els = getEls('.image-frame');
		for (let i = 0; i < els.length; i++)
		{
			const isAutoplay = els[i].classList.contains('autoplay');
			const el:Element = els[i];
			const img:Element = el.querySelector("img");

			//@ts-ignore
			const delay: number = el.dataset.delay ? parseInt(el.dataset.delay) : 0;
			//@ts-ignore
			const scale: number = el.dataset.zoom ? parseFloat(el.dataset.zoom) : 1.25;

			const animation1:AnimeInstance = anime({
				targets: el,
				autoplay: false,
				scale: [
					{value: 0.6, duration: 0},
					{value: 1, duration: 2000}
				],
				clipPath: [
					{value:'inset(100% 0% 0% 0%)', duration: 0},
					{value:'inset(0% 0% 0% 0%)', duration: 1700}
				],
				easing: 'easeInOutQuint',
				delay: delay,
			});
			const animation2:AnimeInstance = anime({
				targets: img,
				autoplay: false,
				scale: [1,scale],
				duration: 4000,
				easing:"easeOutSine",
				delay: delay+800,
			});

			if (isAutoplay) {

				//Find any parent of this element that has the data-image-trigger attribute.
				//If so, then attach the visibility trigger to it, rather than the image.

				let triggerEl = findParentEl(els[i], "[data-image-trigger]");
				if (!triggerEl) triggerEl = els[i];

				app.scroller.addVisibilityTrigger(triggerEl, (dir) => {
					if (animation1 && !animation1.completed) {
						animation1.play();
						animation2.play();
					}
				}, AnimatedImages.TRIGGER_ANIMATION_AT);
			} else {
				els[i].addEventListener("play", (e) => {
					if (animation1 && !animation1.completed) {
						animation1.play();
						animation2.play();
					}
				}, {once: true});
			}
		}
	}
}
